module.exports = __webpack_public_path__ + "c7bd2dfd0490ea85fb7f8573403dbb3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/images/kitchen.jpg
// module id = 538
// module chunks = 0